import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { AlertToastType } from '../../services/alert.service';

@Component({
  selector: 'lib-alert-snackbar',
  templateUrl: './alert-snackbar.component.html',
  styleUrls: ['./alert-snackbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AlertSnackbarComponent {
  @Input() data: { message: string; type: AlertToastType } = { message: '', type: 'success' };
  @Output() dismissed = new EventEmitter<void>();

  get icon(): string {
    if (this.data.type === 'success') return 'check_circle';
    if (this.data.type === 'warning') return 'warning';
    return 'error';
  }

  dismiss(): void {
    this.dismissed.emit();
  }
}
